export default "__VITE_ASSET__057256b9__"